module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/Neighborhood_01-Cover.png";